/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class ProposalDeliveryStatus.
* @enum {}
* @readonly
*/
export default class ProposalDeliveryStatus {
    
        /**
         * value: "scheduled"
         * @const
         */
        "scheduled" = "scheduled";

    
        /**
         * value: "sent"
         * @const
         */
        "sent" = "sent";

    
        /**
         * value: "failed"
         * @const
         */
        "failed" = "failed";

    
        /**
         * value: "canceled"
         * @const
         */
        "canceled" = "canceled";

    

    /**
    * Returns a <code>ProposalDeliveryStatus</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/ProposalDeliveryStatus} The enum <code>ProposalDeliveryStatus</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

